import { Regimen } from 'client/app/app-constant-types';
import { ProcessedRegimen, ProcessedRegimenProduct, RegimenViewState, DisplayStateOptions } from './regimen.types';

export function processRegimen(regimen: Regimen): ProcessedRegimen {
  if (!regimen?.objectId) return regimen as ProcessedRegimen;
  const processed: ProcessedRegimen = { ...regimen };
  processed.totalMRP = Math.round(processed.fixedPriceMRP ?? 0);
  processed.totalSP = processed.fixedPrice;
  processed.discount = processed.totalMRP
    ? Math.floor(((processed.totalMRP - (processed.totalSP ?? 0)) * 100) / processed.totalMRP)
    : 0;

  (['morning', 'night'] as const).forEach(slot => {
    (processed[slot] ?? []).forEach((item: ProcessedRegimenProduct) => {
      if (item.instruction && typeof item.instruction === 'string') {
        item.instruction = item.instruction.split('.').filter((ins: string) => ins.trim().length > 0);
      } else if (!item.instruction) {
        item.instruction = [item.product?.purposeDescription ?? '', 'Purchase regimen to see your instructions.'];
      }
    });
  });

  return processed;
}

export function isRegimenBeingPrepared(regimen: ProcessedRegimen): boolean {
  if (!regimen.objectId || regimen.expired || !regimen.activeFrom || regimen.active || regimen.orderPlaced) return false;
  const toleranceSec = 5;
  const regimenShowTime = new Date(regimen.activeFrom.iso).getTime();
  return (regimenShowTime - Date.now()) / 1000 > toleranceSec;
}

export function getDisplayState(regimen: ProcessedRegimen | null, options?: DisplayStateOptions): RegimenViewState {
  if (!regimen?.objectId) {
    if (options?.consultationSession?.get('PrivateMainConcern')) return 'regimen_chat';
    return 'regimen_empty';
  }
  if (isRegimenBeingPrepared(regimen)) return 'regimen_preparation';
  const morning = regimen.morning ?? [];
  const night = regimen.night ?? [];
  const hasProducts = morning.length + night.length > 0;
  if (!hasProducts) return 'regimen_consultation';
  const hasInstructionSet = morning.every((p: ProcessedRegimenProduct) => p.instructionSet !== undefined)
    && night.every((p: ProcessedRegimenProduct) => p.instructionSet !== undefined);
  if (regimen.showProductSummary && regimen.active && hasInstructionSet) return 'regimen_instruction';
  return 'regimen_unpaid';
}
